import { render, staticRenderFns } from "./AdminRemote.vue?vue&type=template&id=710479c8&scoped=true&"
import script from "./AdminRemote.vue?vue&type=script&lang=js&"
export * from "./AdminRemote.vue?vue&type=script&lang=js&"
import style0 from "./AdminRemote.vue?vue&type=style&index=0&id=710479c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710479c8",
  null
  
)

export default component.exports